export var EPricingRuleType = /*#__PURE__*/function (EPricingRuleType) {
  /** Calculate the total number of tickets across all variations. */
  EPricingRuleType["quantity"] = "quantity";
  /** Calculate the total number of tickets of a single variation. */
  EPricingRuleType["time"] = "time";
  /** Early bird pricing rule */
  EPricingRuleType["earlyBird"] = "earlyBird";
  return EPricingRuleType;
}(EPricingRuleType || {});
/** (Legacy) Integer enum to be used only when the server cannot return a string value */
export var EPricingRuleTypeInt = /*#__PURE__*/function (EPricingRuleTypeInt) {
  /** Calculate the total number of tickets across all variations. */
  EPricingRuleTypeInt[EPricingRuleTypeInt["quantity"] = 1] = "quantity";
  /** Calculate the total number of tickets of a single variation. */
  EPricingRuleTypeInt[EPricingRuleTypeInt["time"] = 2] = "time";
  /** Early bird pricing rule */
  EPricingRuleTypeInt[EPricingRuleTypeInt["earlyBird"] = 3] = "earlyBird";
  return EPricingRuleTypeInt;
}(EPricingRuleTypeInt || {});
export var EQuantityCalculation = /*#__PURE__*/function (EQuantityCalculation) {
  /** Calculate the total number of tickets across all variations. */
  EQuantityCalculation["perProduct"] = "perProduct";
  EQuantityCalculation["ticketTotal"] = "ticketTotal";
  /** Calculate the total number of tickets of a single variation. */
  EQuantityCalculation["perVariation"] = "perVariation";
  EQuantityCalculation["ticketTypeTotal"] = "ticketTypeTotal";
  return EQuantityCalculation;
}(EQuantityCalculation || {});
/** (Legacy) Integer enum to be used only when the server cannot return a string value */
export var EQuantityCalculationInt = /*#__PURE__*/function (EQuantityCalculationInt) {
  /** Calculate the total number of tickets across all variations. */
  EQuantityCalculationInt[EQuantityCalculationInt["perProduct"] = 0] = "perProduct";
  /** Calculate the total number of tickets of a single variation. */
  EQuantityCalculationInt[EQuantityCalculationInt["perVariation"] = 1] = "perVariation";
  return EQuantityCalculationInt;
}(EQuantityCalculationInt || {});
export var EDaysOfWeek = /*#__PURE__*/function (EDaysOfWeek) {
  EDaysOfWeek[EDaysOfWeek["Sunday"] = 0] = "Sunday";
  EDaysOfWeek[EDaysOfWeek["Monday"] = 1] = "Monday";
  EDaysOfWeek[EDaysOfWeek["Tuesday"] = 2] = "Tuesday";
  EDaysOfWeek[EDaysOfWeek["Wednesday"] = 3] = "Wednesday";
  EDaysOfWeek[EDaysOfWeek["Thursday"] = 4] = "Thursday";
  EDaysOfWeek[EDaysOfWeek["Friday"] = 5] = "Friday";
  EDaysOfWeek[EDaysOfWeek["Saturday"] = 6] = "Saturday";
  EDaysOfWeek[EDaysOfWeek["sunday"] = 0] = "sunday";
  EDaysOfWeek[EDaysOfWeek["monday"] = 1] = "monday";
  EDaysOfWeek[EDaysOfWeek["tuesday"] = 2] = "tuesday";
  EDaysOfWeek[EDaysOfWeek["wednesday"] = 3] = "wednesday";
  EDaysOfWeek[EDaysOfWeek["thursday"] = 4] = "thursday";
  EDaysOfWeek[EDaysOfWeek["friday"] = 5] = "friday";
  EDaysOfWeek[EDaysOfWeek["saturday"] = 6] = "saturday";
  return EDaysOfWeek;
}(EDaysOfWeek || {});